export const MDP_TAILLE_MIN = 6;
export const MDP_TAILLE_MAX = 16;



// WEBPACK FOOTER //
// ./src/App_Data/Consts.js